import createCachedSelector from 're-reselect'
import selectIntegrationsById from './selectIntegrationsById'

export default createCachedSelector(
  selectIntegrationsById,
  (state, integrationId) => integrationId,
  (byId, integrationId) => byId[integrationId]
)((state, integrationId) => integrationId || 'unknown')
